import { useEffect } from 'react';
import { Box, IconButton, MenuItem, Select, SelectChangeEvent, Typography } from '@mui/material';
import RefreshRoundedIcon from '@mui/icons-material/RefreshRounded';

const INTERVAL_OPTIONS = [
  { label: '5분', value: 5 },
  { label: '10분', value: 10 },
  { label: '30분', value: 30 },
];

type Props = {
  intervalMinutes: number;
  onIntervalChange: (minutes: number) => void;
  onRefresh: () => void;
  lastUpdated?: string;
};

export default function RealtimeRefreshControl({
  intervalMinutes,
  onIntervalChange,
  onRefresh,
  lastUpdated,
}: Props) {
  useEffect(() => {
    const id = setInterval(onRefresh, intervalMinutes * 60 * 1000);
    return () => clearInterval(id);
  }, [intervalMinutes, onRefresh]);

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: 1.5,
        p: 1.5,
        borderRadius: 3,
        bgcolor: '#ffffff',
        boxShadow: '0 1px 3px rgba(0, 0, 0, 0.04)',
        border: '1px solid #f1f5f9',
        width: 'fit-content',
      }}
    >
      <IconButton onClick={onRefresh} size="small" sx={{ color: '#0044D2' }}>
        <RefreshRoundedIcon />
      </IconButton>
      <Select
        value={intervalMinutes}
        onChange={(e: SelectChangeEvent<number>) => onIntervalChange(Number(e.target.value))}
        size="small"
        sx={{ minWidth: 100 }}
      >
        {INTERVAL_OPTIONS.map((opt) => (
          <MenuItem key={opt.value} value={opt.value}>
            {opt.label}마다
          </MenuItem>
        ))}
      </Select>
      {lastUpdated && (
        <Typography fontSize="0.8rem" color="#94a3b8" sx={{ whiteSpace: 'nowrap' }}>
          마지막 갱신: {lastUpdated}
        </Typography>
      )}
    </Box>
  );
}
